<template>
  <v-dialog v-model="dialog" scrollable width="90%" v-if="detail" :key="detail.id">
    <!-- <v-card>
      <v-card-title>
        {{ detail.location }}
        <v-spacer />
        <v-icon @click="mCloseDetailDialog">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: calc(90vh)">
        <v-radio-group v-model="dialogm1" column>
          <v-radio label="Bahamas, The" value="bahamas"></v-radio>
          <v-radio label="Bahrain" value="bahrain"></v-radio>
          <v-radio label="Bangladesh" value="bangladesh"></v-radio>
          <v-radio label="Barbados" value="barbados"></v-radio>
          <v-radio label="Belarus" value="belarus"></v-radio>
          <v-radio label="Belgium" value="belgium"></v-radio>
          <v-radio label="Belize" value="belize"></v-radio>
          <v-radio label="Benin" value="benin"></v-radio>
          <v-radio label="Bhutan" value="bhutan"></v-radio>
          <v-radio label="Bolivia" value="bolivia"></v-radio>
          <v-radio label="Bosnia and Herzegovina" value="bosnia"></v-radio>
          <v-radio label="Botswana" value="botswana"></v-radio>
          <v-radio label="Brazil" value="brazil"></v-radio>
          <v-radio label="Brunei" value="brunei"></v-radio>
          <v-radio label="Bulgaria" value="bulgaria"></v-radio>
          <v-radio label="Burkina Faso" value="burkina"></v-radio>
          <v-radio label="Burma" value="burma"></v-radio>
          <v-radio label="Burundi" value="burundi"></v-radio>
        </v-radio-group>
      </v-card-text>
    </v-card>  -->
    <div style="width: 100%">
      <v-toolbar color="cyan" dark tabs>
        <v-toolbar-title>{{ detail.location }}</v-toolbar-title>

        <v-spacer></v-spacer>
<!-- 
        <v-btn icon>
          <v-icon>search</v-icon>
        </v-btn> -->

        <v-btn icon @click="mCloseDetailDialog">
          <v-icon>close</v-icon>
        </v-btn>

        <template v-slot:extension>
          <v-tabs
            v-model="currentItem"
            color="transparent"
            fixed-tabs
            slider-color="yellow"
          >
            <v-tab v-for="item in items" :key="item.name" :href="'#tab-' + item.name">
              {{ item.name }}
            </v-tab>

          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="currentItem">
        <v-tab-item
          v-for="item in items"
          :key="item.name"
          :value="'tab-' + item.name"
        >
          <v-card flat>
            <v-card-text style="height: calc(90vh)">
              <h2>{{ item.name }}</h2>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-dialog>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const oilNamespace = createNamespacedHelpers("oil");

import { items } from "./config/detail";


export default {
  data() {
    return {
      currentItem: "tab-Overview",
      dialogm1: false,
      items: { ...items },
    };
  },
  computed: {
    ...oilNamespace.mapState({
      detailDialog: (state) => state.detailDialog,
      detail: (state) => state.detail,
    }),
    dialog: {
      get() {
        return this.detailDialog;
      },
      set() {
        this.mCloseDetailDialog();
      },
    },
  },
  methods: {
    ...oilNamespace.mapMutations(["mOpenDetailDialog", "mCloseDetailDialog"]),
  },
};
</script>